import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { uuid, TUuidCodec } from "../../../shared/src/codecs/types/uuid";
import { integer, TIntegerCodec } from "../../../shared/src/codecs/types/integer";

type TAutoReassignUserWorkInputCodec = TRequiredCodec<{
    user_id: TUuidCodec;
}>;

type TAutoReassignUserWorkOutputCodec = TRequiredCodec<{
    emails_unassigned: TIntegerCodec;
    roadblocks_reassigned_to_case_handler: TIntegerCodec;
    roadblocks_reassigned_to_fallback: TIntegerCodec;
}>;

export const AutoReassignUserWorkFormIO: TFormIOCodec<
    TAutoReassignUserWorkInputCodec,
    TAutoReassignUserWorkOutputCodec
> = formIO(
    required({
        user_id: uuid(),
    }),
    required({
        emails_unassigned: integer(),
        roadblocks_reassigned_to_case_handler: integer(),
        roadblocks_reassigned_to_fallback: integer(),
    }),
);

export type TAutoReassignUserWorkFormIOCodec = typeof AutoReassignUserWorkFormIO;
export type TAutoReassignUserWorkFormIO = TTypeOfCodec<TAutoReassignUserWorkFormIOCodec>;
